import { useState } from "react";
import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import { Link } from "react-router-dom";
import { faqItems } from "../../mocks/services";

const additionalFAQs = [
  {
    question: "Does Studio 1323 work on projects outside Santa Monica?",
    answer: "Yes — while we are based in Santa Monica, we actively work across greater Los Angeles including Brentwood, Pacific Palisades, Malibu, Venice, Beverly Hills, and Culver City. We are licensed throughout California and can take on projects statewide for the right fit.",
  },
  {
    question: "How do I get started?",
    answer: "The first step is a complimentary initial consultation — either at our Santa Monica studio or via video call. We discuss your project scope, site, timeline, and budget. From there, we provide a fee proposal tailored to your specific project.",
  },
  {
    question: "What information should I bring to a first meeting?",
    answer: "Any existing drawings or surveys of your site are helpful, along with a sense of your budget range and project timeline. Don't worry if you don't have everything — the first meeting is exploratory, and we help clients define their program as part of the process.",
  },
];

const allFAQs = [...faqItems, ...additionalFAQs];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <div className="bg-arch-cream font-sans">
      <Header />
      <main>
        {/* Header */}
        <section className="pt-36 pb-14 px-8 lg:px-14 bg-white border-b border-arch-border">
          <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-4">Common Questions</p>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
            <h1 className="font-serif text-5xl lg:text-6xl text-arch-charcoal font-light leading-tight">
              FAQ
            </h1>
            <p className="text-arch-gray text-sm font-light leading-relaxed max-w-sm">
              Answers to the questions we hear most often from clients in Santa Monica and across Los Angeles.
            </p>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 px-8 lg:px-14 bg-arch-cream">
          <div className="max-w-3xl mx-auto divide-y divide-arch-border border-t border-arch-border">
            {allFAQs.map((item, i) => (
              <div key={i} className="py-6">
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-center justify-between text-left gap-4 cursor-pointer group"
                >
                  <h2 className="text-arch-charcoal text-sm lg:text-base font-medium leading-snug group-hover:text-arch-gray transition-colors">
                    {item.question}
                  </h2>
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 border border-arch-border rounded-full">
                    <i className={`${open === i ? "ri-subtract-line" : "ri-add-line"} text-arch-charcoal text-sm transition-all`} />
                  </div>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${open === i ? "max-h-64 opacity-100 mt-4" : "max-h-0 opacity-0"}`}>
                  <p className="text-arch-gray text-sm font-light leading-relaxed">{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 px-8 lg:px-14 bg-white border-t border-arch-border text-center">
          <h2 className="font-serif text-3xl text-arch-charcoal font-light mb-4">Still have questions?</h2>
          <p className="text-arch-gray text-sm font-light mb-8 max-w-md mx-auto">Reach out directly or schedule a complimentary initial consultation.</p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link to="/contact" className="inline-flex items-center gap-2 bg-arch-charcoal text-white px-7 py-3.5 text-xs tracking-[0.15em] uppercase font-semibold hover:bg-arch-black transition-all rounded-md cursor-pointer whitespace-nowrap">
              Request Consultation <i className="ri-arrow-right-line" />
            </Link>
            <a href="tel:+13105551323" className="inline-flex items-center gap-2 border border-arch-charcoal text-arch-charcoal px-7 py-3.5 text-xs tracking-[0.15em] uppercase font-medium hover:bg-arch-charcoal hover:text-white transition-all rounded-md cursor-pointer whitespace-nowrap">
              <i className="ri-phone-line" /> (310) 555-1323
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
